/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { messaging_EditMessageRequest } from '../models/messaging_EditMessageRequest';
import type { messaging_MessageResponse } from '../models/messaging_MessageResponse';
import type { messaging_SendMessageRequest } from '../models/messaging_SendMessageRequest';
import type { messaging_UnreadCountResponse } from '../models/messaging_UnreadCountResponse';
import type { shared_SuccessResponse } from '../models/shared_SuccessResponse';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class MessagesService {
    /**
     * Send a message to a conversation
     * Send a new message to an existing conversation
     * @param id Conversation ID
     * @param request Message content
     * @returns messaging_MessageResponse Created
     * @throws ApiError
     */
    public static postApiV1ConversationsMessages(
        id: string,
        request: messaging_SendMessageRequest,
    ): CancelablePromise<messaging_MessageResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/conversations/{id}/messages',
            path: {
                'id': id,
            },
            body: request,
            errors: {
                400: `Validation error`,
                401: `Authentication required`,
                403: `Organization ID not found in token`,
                404: `Conversation not found`,
                500: `Internal server error`,
            },
        });
    }
    /**
     * Delete a message
     * Delete a message. Hard delete within 15 minutes, soft delete after.
     * @param id Message ID
     * @returns shared_SuccessResponse OK
     * @throws ApiError
     */
    public static deleteApiV1Messages(
        id: string,
    ): CancelablePromise<shared_SuccessResponse> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/v1/messages/{id}',
            path: {
                'id': id,
            },
            errors: {
                401: `Authentication required`,
                403: `Not the message owner`,
                404: `Message not found`,
                500: `Internal server error`,
            },
        });
    }
    /**
     * Edit a message
     * Edit a message within the 15-minute edit window
     * @param id Message ID
     * @param request Updated message content
     * @returns shared_SuccessResponse OK
     * @throws ApiError
     */
    public static putApiV1Messages(
        id: string,
        request: messaging_EditMessageRequest,
    ): CancelablePromise<shared_SuccessResponse> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/v1/messages/{id}',
            path: {
                'id': id,
            },
            body: request,
            errors: {
                400: `Validation error`,
                401: `Authentication required`,
                403: `Not the message owner`,
                404: `Message not found`,
                422: `Edit window expired`,
                500: `Internal server error`,
            },
        });
    }
    /**
     * Get unread message count
     * Get the total unread message count for the current user
     * @param groupIds Filter by group IDs (contacts: accessible conversations; employees: the inbox view when scoped=true)
     * @param audience Count only this audience (family or staff)
     * @param scoped Employees only: count just the active threads GET /conversations lists for the same group_ids, childcare_ids and include_office. Omitted counts every thread of the organisation.
     * @param childcareIds Employees only, with scoped=true: childcare IDs of the inbox view
     * @param includeOffice Employees only, with scoped=true: also match office threads. Always on for admins.
     * @returns messaging_UnreadCountResponse OK
     * @throws ApiError
     */
    public static getApiV1MessagesUnreadCount(
        groupIds?: Array<string>,
        audience?: 'family' | 'staff',
        scoped?: boolean,
        childcareIds?: Array<string>,
        includeOffice?: boolean,
    ): CancelablePromise<messaging_UnreadCountResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/messages/unread-count',
            query: {
                'group_ids': groupIds,
                'audience': audience,
                'scoped': scoped,
                'childcare_ids': childcareIds,
                'include_office': includeOffice,
            },
            errors: {
                400: `Invalid audience, scoped, childcare_ids or include_office`,
                401: `Authentication required`,
                403: `Organization ID not found`,
                500: `Internal server error`,
            },
        });
    }
}
